<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label>Подъезд</label>
    <el-select
      placeholder="Выберите подъезд"
      filterable
      v-model="localValue"
      :disabled="disabled"
      >
      <el-option
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :value="option.value">
      </el-option>
    </el-select>
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
import { getList } from '@/services/__common.service'

export default {
  name: 'block-field',
  props: {
    value: [String, Number],
    error: Array,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue: '',
      options: []
    }
  },
  mounted () {
    this.localValue = this.value

    this.getList('/blocks', 'number', 'asc').then((response) => {
      this.options = response.data['results'].map(block => {
        return { value: block.id, label: block.full_name }
      })
    })
  },
  watch: {
    value: function (val) {
      this.localValue = val
    },
    localValue: function (val) {
      this.updateValue(val)
    }
  },
  methods: {
    getList: getList,
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Block.vue?9e8655fe